export const ARTICLE_BREADCRUMBS = 'obd-dtc';
export const ARTICLE_CATEGORY = 'obd-dtc';
export const DEFAULT_CODE = 'index';
